import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import { Button, Col, Divider, Row, Switch, Typography } from 'antd';
import {
  useActivateDeactivateTypeMutation,
  useGetAllSearchTypesQuery,
  useRunReindexDatabaseMutation,
  useRunReindexFilesMutation,
} from '../../../../../redux/services/search.jsx';
import SearchTypeTable from './SearchTypeTable.jsx';

const SearchAdminPage = () => {
  const { t } = useTranslation();

  const [triggerReindexDatabase, { isSuccess: databaseResult }] =
    useRunReindexDatabaseMutation();
  const [triggerReindexFile, { isSuccess: fileResult }] =
    useRunReindexFilesMutation();
  const { data, isLoading, refetch } = useGetAllSearchTypesQuery();
  const [changeStatus] = useActivateDeactivateTypeMutation();

  useEffect(() => {
    document.title = t('Vyhľadavané modely') + ' - FRI CMS';
  }, []); // Runs on mount

  const activateDeactivateSearchableType = (id, active) => {
    changeStatus({ id: id, active: active === 0 }).then(() => refetch());
  };

  const customSettings = (row) => {
    return (
      <div style={{ display: 'flex' }}>
        <Switch
          value={row.active}
          checked={row.active}
          onChange={() => {
            activateDeactivateSearchableType(row.id, row.active);
          }}
        />
      </div>
    );
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Vyhľadavané modely')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'search-admin'}
      />
      <div style={{ margin: '10px' }}>
        {/*The new Laravell not support needed command for import*/}
        {/*<CollapseBlock*/}
        {/*  title={t('Správa dát')}>*/}
        {/*  <Row align={"middle"}>*/}
        {/*    <Col span={21}>*/}
        {/*      <Typography>*/}
        {/*        {t('Zjednotenie a indexovanie dát do Elasticsearch')}*/}
        {/*      </Typography>*/}
        {/*    </Col>*/}
        {/*    <Col span={3}>*/}
        {/*      <Button*/}
        {/*        type="primary"*/}
        {/*        onClick={() => {*/}
        {/*          triggerReindexDatabase();*/}
        {/*        }}>*/}
        {/*        {t('Vykonať')}*/}
        {/*      </Button>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*  <Divider style={{margin: 0}}/>*/}
        {/*  <Row align={"middle"}>*/}
        {/*    <Col span={21}>*/}
        {/*      <Typography>*/}
        {/*        {t('Indexovanie súborov do ElasticSearch')}*/}
        {/*      </Typography>*/}
        {/*    </Col>*/}
        {/*    <Col span={3}>*/}
        {/*      <Button*/}
        {/*        type="primary"*/}
        {/*        disabled*/}
        {/*        onClick={() => {*/}
        {/*          triggerReindexFile();*/}
        {/*        }}>*/}
        {/*        {t('Vykonať')}*/}
        {/*      </Button>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*</CollapseBlock>*/}
        <CollapseBlock title={t('Zoznam vyhľadávaných modelov')}>
          <SearchTypeTable searchTypes={data} customSettings={customSettings} />
        </CollapseBlock>
      </div>
    </>
  );
};

export default SearchAdminPage;
